import { Box, Stack, SwipeableDrawer, SxProps, Theme } from '@mui/material';
import { useIsIOS } from '../hooks';
import { MOBILE_DRAWER_MAX_HEIGHT } from '../config/constants';

const DRAWER_BLEEDING = 56;

export type MobileSwipeableDrawerProps = {
  isOpen: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  children: React.ReactNode;
  bottomOffset?: number;
  hideBackdrop?: boolean;
  zIndex?: number;
  disableScroll?: boolean;
  containerSx?: SxProps<Theme>;
};

export function MobileSwipeableDrawer({
  isOpen,
  children,
  onOpen,
  onClose,
  hideBackdrop,
  zIndex,
  bottomOffset = 0,
  disableScroll,
  containerSx,
}: MobileSwipeableDrawerProps) {
  const isIOS = useIsIOS();

  return (
    <SwipeableDrawer
      id="swipeable-drawer"
      anchor="bottom"
      open={isOpen}
      onClose={() => onClose?.()}
      onOpen={() => onOpen?.()}
      swipeAreaWidth={DRAWER_BLEEDING}
      disableSwipeToOpen
      keepMounted
      hideBackdrop={hideBackdrop}
      disableDiscovery={isIOS}
      disableBackdropTransition
      data-treedistestid="drawer-mobile-swipeable"
      ModalProps={{
        sx: { height: hideBackdrop ? 0 : '100%', zIndex },
      }}
      sx={{
        top: 'auto',
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0,0,0,0.6)',
          // Disable expensive backdrop filters on iOS for better performance
          ...(isIOS
            ? {}
            : {
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
              }),
        },
      }}
      slotProps={{
        paper: {
          sx: {
            width: '100%',
            backdropFilter: 'none !important',
            boxShadow: 'none !important',
            height: 'auto',
            bottom: `${bottomOffset}px`,
            maxHeight: `calc(${MOBILE_DRAWER_MAX_HEIGHT} - ${bottomOffset}px)`,
            minHeight: '30vh',

            // hide scrollbar
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            backgroundColor: 'transparent !important',
          },
        },
      }}
    >
      <Stack position="relative" pt={2} overflow="hidden">
        <Box
          sx={{
            position: 'absolute',
            top: '2px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 50,
            height: 6,
            backgroundColor: '#fff',
            borderRadius: 3,
          }}
        />

        <Box
          className="hide-scrollbar"
          position="relative"
          sx={{
            background: '#fff',
            borderRadius: '20px 20px 0 0',
            overflow: disableScroll ? 'hidden' : 'auto',
            ...containerSx,
          }}
        >
          {children}
        </Box>
      </Stack>
    </SwipeableDrawer>
  );
}
